import React from 'react';
import { Card, Col } from 'reactstrap';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { IconButton } from '../../../../../components/IconButton';

export function InterviewKitCard(props: {
  title: string;
  titleClassName?: string;
  canFillScorecard?: boolean;
  handleFillScorecard?: () => void;
  isLoadingFillScorecard?: boolean;
  children: JSX.Element;
}) {
  return (
    <Col xs='6'>
      <Card className={classNames('pt-4', 'pb-6h')}>
        <div
          className={classNames(
            'd-flex px-4 justify-content-between',
            props.titleClassName,
          )}
        >
          <div className={classNames('fw-semibold fs-3')}>{props.title}</div>

          {props.canFillScorecard && (
            <IconButton
              buttonText='Fill in Scorecard'
              color='borderless'
              iconName='bi-clipboard-check'
              textClass='fs-6 fw-normal'
              iconClass='fs-6'
              buttonClass='p-0'
              onClick={props.handleFillScorecard}
              isLoading={props.isLoadingFillScorecard}
            />
          )}
        </div>
        <div className={classNames('px-4', styles['interview-kit-card'])}>
          {props.children}
        </div>
      </Card>
    </Col>
  );
}
